import { createFileRoute } from "@tanstack/react-router";
import { AdminUsersTable } from "@/pages/Admin/AdminUsersTable";

export const Route = createFileRoute("/admin/users/")({
  component: AdminUsersTable,
});
